import moment from 'moment-timezone';

import {
  IMaintenance,
  IMaintenanceData,
  IMaintenanceFieldError,
  IMaintenanceFieldErrorData
} from './maintenance.types';

export class Maintenance implements IMaintenance {
  readonly id: number;
  readonly start: string | Date;
  readonly end: string | Date;
  readonly created_at: string | Date;
  readonly updated_at: string | Date;

  constructor(data: IMaintenanceData) {
    this.id = data.id;
    this.start = data.start;
    this.end = data.end;

    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
  }

  validate(): boolean {
    //TODO: Add Validators
    throw new Error('Method not implemented.');
  }

  get isUnderMaintenance(): boolean {
    return moment(new Date()).isBetween(this.start, this.end, 'second');
  }

  get color(): string {
    return this.isUnderMaintenance ? 'error' : 'warning';
  }

  toString(): string {
    if (this.isUnderMaintenance) {
      return `now and ${moment
        .tz(this.end, moment.tz.guess())
        .format('dddd, MMMM D, h:mma z')}`;
    } else {
      return `${moment
        .tz(this.start, moment.tz.guess())
        .format('dddd, MMMM D, h:mma z')} and ${moment
        .tz(this.end, moment.tz.guess())
        .format('dddd, MMMM D, h:mma z')}`;
    }
  }
}

export class MaintenanceFieldError implements IMaintenanceFieldError {
  readonly start: string[] = [];
  readonly end: string[] = [];
  readonly created_at: string[] = [];
  readonly updated_at: string[] = [];

  constructor(data?: IMaintenanceFieldErrorData) {
    if (data) {
      if (data.start) {
        this.start = data.start;
      }

      if (data.end) {
        this.end = data.end;
      }

      if (data.created_at) {
        this.created_at = data.created_at;
      }

      if (data.updated_at) {
        this.updated_at = data.updated_at;
      }
    }
  }

  clearErrors(): void {
    this.start.splice(0, this.start.length);
    this.end.splice(0, this.end.length);
    this.created_at.splice(0, this.created_at.length);
    this.updated_at.splice(0, this.updated_at.length);
  }

  static isMaintenanceFieldError(data: IMaintenanceFieldErrorData): boolean {
    if (data.start && Array.isArray(data.start)) {
      return true;
    }
    if (data.end && Array.isArray(data.end)) {
      return true;
    }
    if (data.created_at && Array.isArray(data.created_at)) {
      return true;
    }
    if (data.updated_at && Array.isArray(data.updated_at)) {
      return true;
    }

    return false;
  }
}
